import React, { useState, useEffect } from 'react';
import Strategy from './Strategy';
import Timeline from './Timeline';
import Team from './Team';
import styles from './AboutUs.module.css';
import Footer from '../shared/Footer';

// Carousel background images for the hero section
const TEAM_IMAGES = [
  '/images/carousel/careers1.JPG',
  '/images/carousel/careers2.JPG',
  '/images/carousel/careers3.JPG',
  '/images/carousel/careers4.PNG',
  '/images/carousel/careers6.JPG'
];


function AboutUs() {
  // Carousel state management
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slideDirection, setSlideDirection] = useState('next');
  const [nextImageIndex, setNextImageIndex] = useState(1);

  // Auto-advance carousel every 3 seconds (2.2s display + 0.8s transition)
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideDirection('next');
      setIsTransitioning(true);
      const nextIndex = currentImageIndex === TEAM_IMAGES.length - 1 ? 0 : currentImageIndex + 1;
      setNextImageIndex(nextIndex);
      setTimeout(() => {
        setCurrentImageIndex(nextIndex);
        setIsTransitioning(false);
      }, 800);
    }, 3000);

    return () => clearInterval(interval);
  }, [currentImageIndex]);

  // Navigate to previous image in carousel
  const goToPrevious = () => {
    if (isTransitioning) return; // Prevent rapid clicking during transitions
    setSlideDirection('prev');
    setIsTransitioning(true);
    const newIndex = currentImageIndex === 0 ? TEAM_IMAGES.length - 1 : currentImageIndex - 1;
    setNextImageIndex(newIndex);
    setTimeout(() => {
      setCurrentImageIndex(newIndex);
      setIsTransitioning(false);
    }, 800);
  };

  // Navigate to next image in carousel
  const goToNext = () => {
    if (isTransitioning) return; // Prevent rapid clicking during transitions
    setSlideDirection('next');
    setIsTransitioning(true);
    const newIndex = currentImageIndex === TEAM_IMAGES.length - 1 ? 0 : currentImageIndex + 1;
    setNextImageIndex(newIndex);
    setTimeout(() => {
      setCurrentImageIndex(newIndex);
      setIsTransitioning(false);
    }, 800);
  };

  return (
    <div className={styles.section}>
      <div className={styles.container}>
        {/* Hero Section with Carousel Background */}
        <div 
          className={`${styles.hero} ${isTransitioning ? styles.fadeTransition : ''}`}
          style={{ 
            backgroundImage: `url(${process.env.PUBLIC_URL + TEAM_IMAGES[currentImageIndex]})` 
          }}
        >
          {/* Next image overlay for smooth crossfade */}
          {isTransitioning && (
            <div 
              className={styles.nextImageOverlay}
              style={{ 
                backgroundImage: `url(${process.env.PUBLIC_URL + TEAM_IMAGES[nextImageIndex]})` 
              }}
            />
          )}
          <div className={styles.heroOverlay} />
          
          {/* Navigation Arrows */}
          <button 
            className={`${styles.carouselArrow} ${styles.arrowLeft}`}
            onClick={goToPrevious}
            aria-label="Previous image"
          >
            ‹
          </button>
          <button 
            className={`${styles.carouselArrow} ${styles.arrowRight}`}
            onClick={goToNext}
            aria-label="Next image"
          >
            ›
          </button>
          
          <div className={styles.heroContent}>
            <h1 className={styles.title}>About Us</h1>
            <p className={styles.subtitle}>
              Transforming airport operations with AI-driven innovation, shaping the future of aviation technology alongside a global team of industry experts.
            </p>
          </div>
        </div>

        {/* Strategy Section */}
        <div className={styles.strategySection}>
          <Strategy />
        </div>

        {/* Journey Section */}
        <div className={styles.journeySection}>
          <Timeline />
        </div>

        {/* Team Section */}
        <div className={styles.teamSection}>
          <Team />
        </div>


      </div>
      <Footer />
    </div>
  );
}

export default AboutUs;
